/**
 * Area annotation geometry properties — registration and getters.
 *
 * Properties registered here:
 * - area_points (JSON, PROJECT_GLOBAL) — Array<{position: {x,y,z}, pointCloudId?: string}>
 */

import { PropertyType, PropertyValueType } from '../../types';
import { propertyRegistry } from '../../PropertyRegistry';
import { getGlobalPropertyService } from '../../reactive/globalPropertyService';
import { TypedJsonProperty } from '../../reactive/TypedJsonProperty';
import type { AnnotationPoint } from './DistanceGeometryPropertyGetters';

export function registerAreaGeometryProperties() {
  if (!propertyRegistry.isRegistered('area_points')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'area_points',
      name: 'Points',
      valueType: PropertyValueType.JSON,
      defaultValue: '[]',
      annotationTypes: [],
    });
  }
}

registerAreaGeometryProperties();

const areaPointsCache = new Map<string, TypedJsonProperty<AnnotationPoint[]>>();

export function getAreaPointsProperty(annotationId: string): TypedJsonProperty<AnnotationPoint[]> {
  const cached = areaPointsCache.get(annotationId);
  if (cached && !cached.isDestroyed) return cached;

  const service = getGlobalPropertyService();
  const raw = service.getProperty('area_points', annotationId, PropertyType.PROJECT_GLOBAL);
  const typed = new TypedJsonProperty<AnnotationPoint[]>(raw);
  areaPointsCache.set(annotationId, typed);
  return typed;
}
